import React from 'react'

type ConfigErrorProps = {
  error: unknown
}

const ConfigError = ({ error }: ConfigErrorProps) => (
  <div className="p-8 font-sans text-red-700">
    <h1 className="text-xl font-bold">⚠️ Configuration error</h1>
    <p className="mt-2">
      Impossible de charger <code>config.json</code>.
    </p>
    <pre className="mt-4 whitespace-pre-wrap rounded bg-red-50 p-4 border border-red-200">
      {String(error)}
    </pre>
  </div>
)

export default ConfigError
